<div class="card auth-card mx-auto">
  <div class="card-header"><i class="fa fa-user-plus mr-2"></i>Sign up</div>
  <div class="card-body">
    <p>Leave your details and we will set up your account. You will receive an email as soon as your account has been activated.</p>

    <form [formGroup]="registerForm" (ngSubmit)="registerForm.valid && register()" autocomplete="off">
      <app-text-input [formControl]='registerForm.controls["companyname"]' [label]='"Name Company"'></app-text-input>
      <app-text-input [formControl]='registerForm.controls["contact"]' [label]='"Contact"'></app-text-input>
      <app-text-input [formControl]='registerForm.controls["username"]' [label]='"Email Address"'></app-text-input>
      <app-text-input [formControl]='registerForm.controls["phonenumber"]' [label]='"Phone Number"'></app-text-input>

      @if (validationErrors.length > 0) {
        <div class="alert alert-danger py-2">
          <ul class="mb-0 pl-3">
            @for (error of validationErrors; track error) {
              <li>
                {{error.description}}
              </li>
            }
          </ul>
        </div>
      }

      <button [disabled]='!registerForm.valid' class="btn btn-primary btn-block mt-4" type="submit">Register</button>
      <button class="btn btn-outline-secondary btn-block" (click)="cancel()" type="button"><i class="fa fa-arrow-left mr-1"></i>Cancel</button>
    </form>
  </div>
</div>
